var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"gc-status-chip"},[_c('span',{class:{
      active: _vm.status == 'N',
      inactive: _vm.status == 'Y',
    }})])
}
var staticRenderFns = []

export { render, staticRenderFns }